var React = require('react');

function Offsett (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 4.5 2 C 3.125 2 2 3.125 2 4.5 L 2 6 L 3 6 L 3 4.5 C 3 3.664063 3.664063 3 4.5 3 L 11.5 3 C 12.335938 3 13 3.664063 13 4.5 L 13 6 L 11 6 L 13.5 8.5 L 16 6 L 14 6 L 14 4.5 C 14 3.125 12.875 2 11.5 2 Z M 2.5 7.5 L 0 10 L 2 10 L 2 11.5 C 2 12.875 3.125 14 4.5 14 L 11.5 14 C 12.875 14 14 12.875 14 11.5 L 14 10 L 13 10 L 13 11.5 C 13 12.335938 12.335938 13 11.5 13 L 4.5 13 C 3.664063 13 3 12.335938 3 11.5 L 3 10 L 5 10 Z"}));
}

Offsett.defaultProps = {"fill":"currentColor","viewBox":"0 0 16 16","width":"32px","height":"32px"};

module.exports = Offsett;

Offsett.default = Offsett;
